<template>
    <div class="kgr-grid kgr-grid--1of2 kgr-grid--gutters kgr-grid--bigGutters">
        <div class="kgr-grid__cell">
            <fieldset class="kgr-row kgr-row--bigMargin">
                <legend class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                    {{ $t('employeeKnowledge.header.testimonials') }}
                </legend>
                <div class="kgr-inputGroup">
                    <kgr-form-row
                        :error="error"
                        field-name="hasFirstAidCertificate"
                    >
                        <kgr-checkbox
                            v-model="employeeKnowledgeData.hasFirstAidCertificate"
                            :label="$t('employeeKnowledge.hasFirstAidCertificate')"
                            @change="changedHasFirstAidCertificate"
                        />
                    </kgr-form-row>
                    <div
                        v-if="employeeKnowledgeData.hasFirstAidCertificate"
                        class="kgr-input-group kgr-input--inline animated fadeIn"
                    >
                        <kgr-form-row
                            :label="$t('employeeKnowledge.firstAidCertificatePresentedAt')"
                            :error="error"
                            inline
                            field-name="firstAidCertificatePresentedAt"
                        >
                            <kgr-date-picker v-model.trim="employeeKnowledgeData.firstAidCertificatePresentedAt" />
                        </kgr-form-row>
                        <kgr-form-row
                            :label="$t('employeeKnowledge.firstAidCertificateValidUntil')"
                            :error="error"
                            inline
                            field-name="firstAidCertificateValidUntil"
                        >
                            <kgr-date-picker v-model.trim="employeeKnowledgeData.firstAidCertificateValidUntil" />
                        </kgr-form-row>
                    </div>
                    <hr class="kgr-separator kgr-separator--light" />
                </div>
                <div class="kgr-inputGroup">
                    <kgr-form-row
                        :error="error"
                        field-name="hasCertificateOfGoodConduct"
                    >
                        <kgr-checkbox
                            v-model="employeeKnowledgeData.hasCertificateOfGoodConduct"
                            :label="$t('employeeKnowledge.hasCertificateOfGoodConduct')"
                            @change="changedHasCertificateOfGoodConduct"
                        />
                    </kgr-form-row>
                    <div
                        v-if="employeeKnowledgeData.hasCertificateOfGoodConduct"
                        class="kgr-input-group kgr-input--inline animated fadeIn"
                    >
                        <kgr-form-row
                            :label="$t('employeeKnowledge.certificateOfGoodConductDelivered')"
                            :error="error"
                            inline
                            field-name="certificateOfGoodConductDelivered"
                        >
                            <kgr-date-picker v-model.trim="employeeKnowledgeData.certificateOfGoodConductDelivered" />
                        </kgr-form-row>
                        <kgr-form-row
                            :label="$t('employeeKnowledge.certificateOfGoodConductValidUntil')"
                            :error="error"
                            inline
                            field-name="dateOfBirth"
                        >
                            <kgr-date-picker v-model.trim="employeeKnowledgeData.certificateOfGoodConductValidUntil" />
                        </kgr-form-row>
                    </div>
                    <hr class="kgr-separator kgr-separator--light" />
                </div>
                <div class="kgr-inputGroup">
                    <kgr-form-row
                        :error="error"
                        field-name="hasHealthCertificate"
                    >
                        <kgr-checkbox
                            v-model="employeeKnowledgeData.hasHealthCertificate"
                            :label="$t('employeeKnowledge.hasHealthCertificate')"
                            @change="changedHasHealthCertificate"
                        />
                    </kgr-form-row>
                    <div
                        v-if="employeeKnowledgeData.hasHealthCertificate"
                        class="kgr-input-group kgr-input--inline animated fadeIn"
                    >
                        <kgr-form-row
                            :label="$t('employeeKnowledge.healthCertificateDelivered')"
                            :error="error"
                            inline
                            field-name="healthCertificateDelivered"
                        >
                            <kgr-date-picker v-model.trim="employeeKnowledgeData.healthCertificateDelivered" />
                        </kgr-form-row>
                        <kgr-form-row
                            :label="$t('employeeKnowledge.healthCertificateValidUntil')"
                            :error="error"
                            inline
                            field-name="healthCertificateValidUntil"
                        >
                            <kgr-date-picker v-model.trim="employeeKnowledgeData.healthCertificateValidUntil" />
                        </kgr-form-row>
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="kgr-grid__cell">
            <fieldset class="kgr-row kgr-row--bigMargin">
                <legend class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                    {{ $t('employeeKnowledge.header.tuition') }}
                </legend>
                <div class="kgr-inputGroup">
                    <kgr-form-row
                        :error="error"
                        field-name="hasFireProtectionPlan"
                    >
                        <kgr-checkbox
                            v-model="employeeKnowledgeData.hasFireProtectionPlan"
                            :label="$t('employeeKnowledge.hasFireProtectionPlan')"
                            @change="changedHasFireProtectionPlan"
                        />
                    </kgr-form-row>
                    <div
                        v-if="employeeKnowledgeData.hasFireProtectionPlan"
                        class="kgr-input-group kgr-input--inline animated fadeIn"
                    >
                        <kgr-form-row
                            :label="$t('employeeKnowledge.fireProtectionPlanDoneAt')"
                            :error="error"
                            inline
                            field-name="fireProtectionPlanDoneAt"
                        >
                            <kgr-date-picker v-model.trim="employeeKnowledgeData.fireProtectionPlanDoneAt" />
                        </kgr-form-row>
                        <kgr-form-row
                            :label="$t('employeeKnowledge.fireProtectionPlanValidUntil')"
                            :error="error"
                            inline
                            field-name="fireProtectionPlanValidUntil"
                        >
                            <kgr-date-picker v-model.trim="employeeKnowledgeData.fireProtectionPlanValidUntil" />
                        </kgr-form-row>
                    </div>
                    <hr class="kgr-separator kgr-separator--light" />
                </div>
                <div class="kgr-inputGroup">
                    <kgr-form-row
                        :error="error"
                        field-name="hasHygienePlan"
                    >
                        <kgr-checkbox
                            v-model="employeeKnowledgeData.hasHygienePlan"
                            :label="$t('employeeKnowledge.hasHygienePlan')"
                            @change="changedHasHygienePlan"
                        />
                    </kgr-form-row>
                    <div
                        v-if="employeeKnowledgeData.hasHygienePlan"
                        class="kgr-input-group kgr-input--inline animated fadeIn"
                    >
                        <kgr-form-row
                            :label="$t('employeeKnowledge.hygienePlanDoneAt')"
                            :error="error"
                            inline
                            field-name="hygienePlanDoneAt"
                        >
                            <kgr-date-picker v-model.trim="employeeKnowledgeData.hygienePlanDoneAt" />
                        </kgr-form-row>
                        <kgr-form-row
                            :label="$t('employeeKnowledge.hygienePlanValidUntil')"
                            :error="error"
                            inline
                            field-name="hygienePlanValidUntil"
                        >
                            <kgr-date-picker v-model.trim="employeeKnowledgeData.hygienePlanValidUntil" />
                        </kgr-form-row>
                    </div>
                    <hr class="kgr-separator kgr-separator--light" />
                </div>
            </fieldset>

            <fieldset class="kgr-row kgr-row--bigMargin">
                <legend class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                    {{ $t('employeeKnowledge.header.misc') }}
                </legend>
                <kgr-form-row
                    :label="$t('employeeKnowledge.miscellaneousSkills')"
                    :error="error"
                    field-name="miscellaneous"
                >
                    <textarea
                        v-model="employeeKnowledgeData.miscellaneousSkills"
                        class="kgr-input"
                        rows="5"
                    ></textarea>
                </kgr-form-row>
            </fieldset>
            <kgr-button
                class="button_save"
                :value="$t('saveChanges')"
                @click="save()"
            />
        </div>
    </div>
</template>

<script>
import Checkbox from '../common/form/checkbox/Checkbox.vue';
import ClubEmployeeKnowledge from '../../js/dto/ClubEmployeeKnowledge';
import DatePicker from '../common/form/picker/DatePicker.vue';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow.vue';
import KgrButton from '../common/form/button/KgrButton.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-checkbox': Checkbox,
        'kgr-date-picker': DatePicker,
        'kgr-form-row': FormRow,
    },
    props: {
        employeeKnowledge: {
            type: ClubEmployeeKnowledge,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            employeeKnowledgeData: null,
        };
    },
    created() {
        this.employeeKnowledgeData = this.employeeKnowledge;
    },
    methods: {
        save() {
            this.$emit('enter', this.employeeKnowledgeData);
        },
        changedHasFirstAidCertificate(value) {
            if (!value && this.employeeKnowledgeData) {
                this.employeeKnowledgeData.firstAidCertificatePresentedAt = null;
                this.employeeKnowledgeData.firstAidCertificateValidUntil = null;
            }
        },
        changedHasCertificateOfGoodConduct(value) {
            if (!value && this.employeeKnowledgeData) {
                this.employeeKnowledgeData.certificateOfGoodConductDelivered = null;
                this.employeeKnowledgeData.certificateOfGoodConductValidUntil = null;
            }
        },
        changedHasHealthCertificate(value) {
            if (!value && this.employeeKnowledgeData) {
                this.employeeKnowledgeData.healthCertificateDelivered = null;
                this.employeeKnowledgeData.healthCertificateValidUntil = null;
            }
        },
        changedHasInfectionProtectionAct(value) {
            if (!value && this.employeeKnowledgeData) {
                this.employeeKnowledgeData.infectionProtectionActDelivered = null;
                this.employeeKnowledgeData.infectionProtectionActValidUntil = null;
            }
        },
        changedHasInfectionProtectionAct2(value) {
            if (!value && this.employeeKnowledgeData) {
                this.employeeKnowledgeData.infectionProtectionAct2Delivered = null;
                this.employeeKnowledgeData.infectionProtectionAct2ValidUntil = null;
            }
        },
        changedHasFireProtectionPlan(value) {
            if (!value && this.employeeKnowledgeData) {
                this.employeeKnowledgeData.fireProtectionPlanDoneAt = null;
                this.employeeKnowledgeData.fireProtectionPlanValidUntil = null;
            }
        },
        changedHasHygienePlan(value) {
            if (!value && this.employeeKnowledgeData) {
                this.employeeKnowledgeData.hygienePlanDoneAt = null;
                this.employeeKnowledgeData.hygienePlanValidUntil = null;
            }
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .button_save {
    display: block;
    margin-left: auto;
}
</style>
